import { SidebarActionTypes } from "./sidebar.types";

export const toggleSidebarHidden = () => ({
  type: SidebarActionTypes.TOGGLE_SIDEBAR_HIDDEN,
});
